import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { createContainer } from "unstated-next";
import { useMemberSearch } from "../hooks/use-member-search";

const useContainer = () => {
  const [nodes, setNodes] = useState({});
  const [filters, setFilters] = useState({});
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(50);
  const { data, isLoading } = useMemberSearch({
    limit,
    nodes,
    filters,
    search,
  });

  useEffect(() => {
    return () => {
      setNodes({});
      setFilters({});
    };
  }, []);

  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setNodes({});
        setFilters({});
        setLimit(50);
      }, 250);
    }
  }, [open]);

  return {
    limit,
    setLimit,
    nodes,
    setNodes,
    filters,
    setFilters,
    open,
    setOpen,
    search,
    setSearch,
    data,
    isLoading,
  };
};

const {
  useContainer: useMemberSearchContainer,
  Provider: MemberSearchProvider,
} = createContainer(useContainer);

export { useMemberSearchContainer, MemberSearchProvider };
